import { SerializedData, Store } from "bernie-core";
import { Logger, NOOP_LOGGER } from "bernie-logger";
import { getBexApiContext } from "bernie-context";
import { ExtendedContextStore } from "../typings/flexFramework/FlexDefinitions";
import { CampaignByIdQuery, CampaignProductType } from "../../__generated__/api";
import { BexApiService } from "../services/BexApiService";
import { FAILED_CAMPAIGN_FETCH } from "../config/systemEvents";
import { CampaignQueryResult } from "components/flexComponents/Deals/typings";

export class DealsStore extends Store {
  public bexApiService: BexApiService;

  public constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER, bexApiService: BexApiService) {
    super(state, logger);
    this.bexApiService = bexApiService;
  }

  public hydrate(data: SerializedData): void {
    // The serialized store as returned by the server exposes a stripped down
    // version of bexApiService with no methods.We delete it here to prevent the override.
    delete data.bexApiService;
    Object.assign(this, data);
  }

  public mapCampaignProductTypes(productTypes: string[]): CampaignProductType[] | [] {
    return productTypes?.map((product: string) => {
      return CampaignProductType[product];
    });
  }

  public async fetchCampaignDeals(
    contextStore: ExtendedContextStore,
    campaignId: string,
    enableTripAttach: boolean,
    pageNumber: number,
    pageSize?: number,
    userLatitude?: number,
    userLongitude?: number,
    userSelectedOrigin?: string,
    displayPropertyCount?: boolean,
    pageName?: string,
    referrerId?: string,
    enableLivePricing?: boolean,
    returnPath?: string
  ): Promise<CampaignQueryResult> {
    const variables: CampaignByIdQuery.Variables = {
      campaignId,
      enableTripAttach,
      pageNumber,
      pageSize,
      context: getBexApiContext(contextStore),
      userLocation: {
        userSelectedOrigin,
        userLatitude,
        userLongitude,
      },
      displayPropertyCount,
      referrer: referrerId,
      enableLivePricing,
      returnPath,
    };
    try {
      const query = await this.bexApiService.fetchCampaignByIdQuery(variables);
      const traceId = query.extensions?.trace?.["Trace-ID"];
      const errorMessage = (query.errors as any)?.[0]?.message;
      const campaign = query.data.campaignRecommendations?.campaigns[0];
      const paginationReferrer = query.data.campaignRecommendations?.paginationInfo?.referrer;

      return { traceId, errorMessage, campaign, paginationReferrer };
    } catch (err) {
      this.logger.logEvent(FAILED_CAMPAIGN_FETCH, "Unexpected error when fetching deals campaign offers", err);

      return { errorMessage: "Unexpected error when fetching deals campaign offers" };
    }
  }
}
